import {
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

import {
  doc,
  getDoc
} from 'firebase/firestore';

import { db } from '../firebase';

import { useAuth } from '../AuthContext';

const UserContext = createContext();

export function UserProvider({ children }) {

  const { currentUser } = useAuth();

  const [userData, setUserData] = useState(null);

  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {

    const cargarUsuario = async () => {

      if (!currentUser) {
        setUserData(null);
        setLoadingUser(false);
        return;
      }

      try {

        const docRef = doc(
          db,
          'users',
          currentUser.uid
        );

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {

          setUserData(docSnap.data());

        } else {

          setUserData(null);

        }

      } catch (error) {

        console.error(error);

      }

      setLoadingUser(false);
    };

    cargarUsuario();

  }, [currentUser]);

  return (

    <UserContext.Provider
      value={{
        userData,
        loadingUser
      }}
    >

      {children}

    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}